/**
 * Variant Carats Display
 * Updates carat display when variants change
 */
(function() {
  'use strict';
  
  // Only initialize once
  if (window.caratDisplayInitialized) return;
  window.caratDisplayInitialized = true;

  function updateVariantCarats(event) {
    const caratsDataScript = document.querySelector('script[data-variant-carats]');
    if (!caratsDataScript) return;

    let variantCaratsData = {};
    try {
      variantCaratsData = JSON.parse(caratsDataScript.textContent);
    } catch (e) {
      console.error('Error parsing variant carats data:', e);
      return;
    }

    const variantId = event.detail?.variant?.id;
    if (!variantId) return;

    const caratsValue = variantCaratsData[variantId];
    const caratsDisplay = document.querySelector('.variant-carats-display');
    
    if (caratsDisplay) {
      if (caratsValue !== null && caratsValue !== undefined && caratsValue !== '') {
        // Get the unit suffix from the data attribute
        const unitSuffix = caratsDisplay.getAttribute('data-unit-suffix') || 'ct';
        // Format the display value with suffix
        caratsDisplay.textContent = caratsValue + unitSuffix;
        caratsDisplay.setAttribute('data-variant-id', variantId);
        const caratDisplay = caratsDisplay.closest('.carat-display');
        if (caratDisplay) {
          caratDisplay.style.display = '';
        }
      } else {
        // Hide if no carats value for this variant
        const caratDisplay = caratsDisplay.closest('.carat-display');
        if (caratDisplay) {
          caratDisplay.style.display = 'none';
        }
      }
    }
  }

  // Listen for variant changes
  document.addEventListener('variant:change', updateVariantCarats);
  document.addEventListener('variant:changed', updateVariantCarats);
})();

